import { Header } from "@src/components/Header"
import { CustomerForm } from "@src/components/customer-form"
import { ar } from "@src/i18n/ar"

export default function NewCustomer() {
  return (
    <>
      <Header title={ar.newCustomer} />
      <CustomerForm />
    </>
  )
}
